import { render } from "./CollectionDetailedSearch.vue?vue&type=template&id=f1e76a0e&scoped=true&ts=true"
import script from "./CollectionDetailedSearch.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearch.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearch.vue?vue&type=style&index=0&id=f1e76a0e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e76a0e"]])

export default __exports__